/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
import {getKontrakDetail, getAccesses, downloadDraft, resubmitAdditionalText} from '../../../api/modules/kontrak'
import {useNavigate, useParams} from 'react-router-dom'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import swal from 'sweetalert'
import {getKontrakAll, getKontrakDetails, approve} from '../../../api/modules/kontrak'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {useDispatch, useSelector} from 'react-redux'
import {setGetNotif} from '../../../_metronic/redux/content'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import AddRemoveJadwal from './AddRemoveJadwal'
import {PopoverText} from '../../../components/Popover/Popover'
import {getUserDetail, getFooterContent} from '../../../api/modules/getdatalist'
import {ViewLetter} from '../../../components/Letter/ViewLetter'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {getDetailFileConfig} from 'src/api/modules/master-data/master'
import {MultiSelect} from 'react-multi-select-component'
import {useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import {BadgeColorKontrak} from 'src/components/BadgeColorKontrak'
import dateformat from 'src/utils/dateformat'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import * as TableUI from '../../../components/Table/Table'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'
import { RichText } from 'src/components'

const ApprovalKontrakDetail: React.FC = () => {
  const intl = useIntl()
  const dispath = useDispatch()
  const notif = useSelector((state: any) => state.notif.getNotif)
  const hakAkses = HakAkses()
  const {roleId} = useAppSelector(authSelector)

  const [show, setShow] = useState(false)
  const [show3, setShow3] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose3 = () => setShow3(false)

  const [kontrakDetail, setKontrakDetail] = useState<any>()

  const handleDetail = (data: any) => {
    setKontrakDetail(data)
    handleShow()
  }

  const {t} = useTranslation()

  // Detail
  const navigate = useNavigate()

  // End Detail

  const [detail, setDetail] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [btnLoadingg, setBtnLoadingg] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [orderId, setOrderId] = useState('')
  const [kontrakId, setKontrakId] = useState('')
  const [kontrakIdSap, setKontrakIdSap] = useState('')
  const [produsen, setProdusen] = useState('')
  const [masaBerlaku, setmasaBerlaku] = useState('')
  const [subDetail, setsubDetail] = useState<any[]>([])
  const [kontrak, setKontrak] = useState<any[]>([])
  const [details, setDetails] = useState<any>()
  const [fixedPrice, setFixedPrice] = useState<any>()
  const [totalQuantum, setTotalQuantum] = useState<any>()
  const [quantumApprove, setQuantumApprove] = useState<any>()
  const [totalQ, setTotalQ] = useState<any>()
  const [kantongApprove, setKantongApprove] = useState<any>()
  const [punit, setPunit] = useState<any>()
  const [requestPrize, setRequestPrize] = useState<any>()
  const [beforePpn, setBeforePpn] = useState<any>()
  const [revisionNote, setRevisionNote] = useState<any>()
  const [rejectNote, setRejectNote] = useState('')
  const [isUpload, setIsUpload] = useState(false)
  const [stateApproval, setStateApproval] = useState(false)
  const [accesses, setAccesses] = useState<any>()
  const [ppn, setppn] = useState(0)
  const [showReject, setShowReject] = useState(false)
  const [roleUser, setRoleUser] = useState('')
  const [showRevision, setShowRevision] = useState(false)
  const [showApprove, setShowApprove] = useState(false)
  const [tempRole, setTempRole] = useState<any[]>([])
  const [fullRole, setFullRole] = useState<any[]>([])
  const [imgHeader, setImgHeader] = useState<any>()
  const [imgFooter, setImgFooter] = useState<any>()

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [sektorid, setsektorid] = useState(0)
  const [customerShip, setCustomerShip] = useState<any>('')
  const [temporarry_status, setTemporarry_status] = useState<any>()
  const cred = localStorage.getItem('credential')

  const [dateTo, setDateTo] = useState('')
  const [dateFrom, setDateFrom] = useState('')
  const [showPreviewForm, setShowPreviewForm] = useState(false)

  const params = useParams()
  const [fileBox, setFileBox] = useState<any>({})
  const ContractID = params.id
  const [loadingDownloadDraft, setLoadingDownloadDraft] = useState<boolean>(false)
  
  const [showAdditional, setShowAdditional] = useState(false)
  const [title, setTitle] = useState('')
  const [customer_pic_name, setCustomer_pic_name] = useState('')
  const [customer_pic_position, setCustomer_pic_position] = useState('')
  const [terms_and_conditions, setTerms_and_conditions] = useState('')
  const [mail_body, setMail_body] = useState('')
  const [customer_attn, setCustomer_attn] = useState('')
  const [port_of_discharge, setPort_of_discharge] = useState('')
  const [lain_lain, setLain_lain] = useState('')
  const [keterangan, setKeterangan] = useState('')
  const [textPenutup, setTextPenutup] = useState('')
  const [noExport, setNoExport] = useState('')
  const [addTextLanguage, setAddTextLanguage] = useState('id')
  const [titleEn, setTitleEn] = useState('')
  const [mail_bodyEn, setMail_bodyEn] = useState('We hereby convey the purchase agreement with the following details:')
  const [customer_attnEn, setCustomer_attnEn] = useState('')
  const [textPenutupEn, setTextPenutupEn] = useState('')
  const [lain_lainEn, setLain_lainEn] = useState('')
  const [keteranganEn, setKeteranganEn] = useState('')
  const [terms_and_conditionsEn, setTerms_and_conditionsEn] = useState('')

  const [assignerName, setassignerName] = useState('')
  const [assignerPos, setassignerPos] = useState('')

  useEffect(() => {
    const getDetail = async () => {
      setLoading(true)
      const res = await getKontrakDetail(params.id, localStorage.getItem('credential'))
      const data = res.data.data

      setStateApproval(res.data.data.show_btn_approve)
      setDetail(data)
      setOrderId(data?.id)
      setKontrakId(data?.contract_number)
      setKontrakIdSap(data?.sip_order_id)
      setProdusen(data?.anper?.name)
      setmasaBerlaku(data?.validity_date_to)
      setsubDetail(data?.order_sub_details)
      setCustomerCode(data?.customer.customer_code)
      setCustomerName(data?.customer.name)
      setCustomerAddress(data?.customer.address)
      setPage(data.current_page)
      setPer(data.per_page)
      setNumberURL(data.links)
      getImg(res.data.data.sales_org_code)
      setppn(res.data.data.order_sub_details[0]?.ppn)
      setsektorid(res.data.data.sector_id)
      setTemporarry_status(data?.temporarry_status)

      if(res.data.data.show_btn_approve){
        setShowPreviewForm(res.data.data.show_btn_approve)
      }

      setTitle(res.data.data?.additional_texts?.title)
      setCustomer_pic_name(res.data.data?.additional_texts?.customer_pic_name)
      setCustomer_pic_position(res.data.data?.additional_texts?.customer_pic_position)
      setTerms_and_conditions(res.data.data?.additional_texts?.terms_and_conditions)
      setMail_body(res.data.data?.additional_texts?.mail_body || 'Bersama ini kami sampaikan persetujuan pembelian dengan rincian sebagai berikut:')
      setCustomer_attn(res.data.data?.additional_texts?.customer_attn)
      setPort_of_discharge(res.data.data?.additional_texts?.port_of_discharge)
      setLain_lain(res.data.data?.additional_texts?.lain_lain)
      setKeterangan(res.data.data?.additional_texts?.keterangan)
      setTextPenutup(res.data.data?.additional_texts?.text_penutup)
      setNoExport(res.data.data?.additional_texts?.no_izin_export)

      setTitleEn(res.data.data?.additional_texts?.title_en)
      setMail_bodyEn(res.data.data?.additional_texts?.mail_body_en || 'We hereby convey the purchase agreement with the following details:')
      setCustomer_attnEn(res.data.data?.additional_texts?.customer_attn_en)
      setTextPenutupEn(res.data.data?.additional_texts?.text_penutup_en)
      setLain_lainEn(res.data.data?.additional_texts?.lain_lain_en)
      setKeteranganEn(res.data.data?.additional_texts?.keterangan_en)
      setTerms_and_conditionsEn(res.data.data?.additional_texts?.terms_and_conditions_en)

      setassignerPos(res.data.data.assigner_position)
      setassignerName(res.data.data.assigner_name)

      setLoading(false)
    }

    const getKontrak = async () => {
      setLoading(true)
      const res = await getKontrakAll(localStorage.getItem('credential'))
      setKontrak(res.data.data.data)
      setNumberURL(res.data.data.links)
      setLoading(false)
      // const kontrakid = useParams()
      // const thisKontrak = kontrak.find((kontrak) => kontrak.id == kontrakid.id)
    }

    const getDetails = async () => {
      setLoading(true)
      const res = await getKontrakDetails(params.id, localStorage.getItem('credential'))

      setDetails(res.data.data)
      setTotalQ(res.data.data?.total_quantum)
      setCustomerShip(
        res.data.data?.customer_ship?.title
          ? res.data.data?.customer_ship?.title + ' ' + res.data.data?.customer_ship?.name
          : res.data.data?.customer_ship?.name
      )
      setQuantumApprove(res.data.data?.detail_quantity?.total_tonnase)
      setKantongApprove(res.data.data?.detail_quantity?.total_pcs)
      setPunit(res.data.data?.order_sub_details?.[0]?.unit)
      setDateTo(res.data.data.validity_date_to)
      setDateFrom(res.data.data.validity_date_from)
      setNumberURL(res.data.data.links)
      let totalPrice = res.data.data.order_sub_details.reduce(
        (a: any, b: any) => a + (b['price_after_ppn'] || 0),
        0
      )
      setFixedPrice(totalPrice)
      let totalQuantum = res.data.data.order_sub_details.reduce(
        (a: any, b: any) => a + (b['price_contract'] || 0),
        0
      )
      setTotalQuantum(totalQuantum)
      let beforePpn = res.data.data.order_sub_details.reduce(
        (a: any, b: any) => a + (b['price_before_ppn'] || 0),
        0
      )
      setBeforePpn(beforePpn)
      handleShowPreview(res.data.data)
      setLoading(false)
    }

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)

      setAccesses(res.data.data)
      setLoading(false)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    try{
      getAllRoleList()
    }catch(err) { console.log(err) }
    try{
      getAccessMenu()
    }catch(err) { console.log(err) }
    try{
      role()
    }catch(err) { console.log(err) }
    try{
      getDetails()
    }catch(err) { console.log(err) }
    try{
      getKontrak()
    }catch(err) { console.log(err) }
    try{
      getDetail()
    }catch(err) { console.log(err) }
  }, [])

  const getImg = async (sales: any) => {
    getDetailFileConfig(sales, 'kop-header').then((res) => {
      setImgHeader(res.data.data)
    })
    getDetailFileConfig(sales, 'kop-footer').then((res) => {
      setImgFooter(res.data.data)
    })
  }

  const handleApprove = async () => {
    setBtnLoading(true)
    await approve(params.id, localStorage.getItem('credential'), i18next.language)
      .then((res) => {
        dispath(setGetNotif(!notif))
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        }).then(() => {
          navigate('/approval/contract')
        })
      })
      .catch((error) => {
        swal({
          title: `${t(error.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleRevisi = async () => {
    setBtnLoadingg(true)
    axios
      .post(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract/revision/${orderId}?credentials=${cred}`,
        {
          revision_note: revisionNote,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        setIsUpload(true)
        dispath(setGetNotif(!notif))
        swal({
          title: `${t('Berhasil Revisi Kontrak')}`,
          icon: 'success',
        })
          .then(() => {
            navigate('/approval/contract')
          })
          .catch((error) => {
            swal({
              title: `${t(error.response.data.message)}`,
              icon: 'error',
            })
          })
      })
      .catch((error) => {})
      .finally(() => {
        handleClose3()
        setBtnLoadingg(false)
      })
  }

  const handleReject = async () => {
    setBtnLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract/reject/${orderId}?credentials=${cred}`,
        {
          reject_note: rejectNote,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        setIsUpload(true)
        dispath(setGetNotif(!notif))
        swal({
          title: `${t('Kontrak Rejected Success')}`,
          icon: 'success',
        })
        navigate('/approval/contract')
      })
      .catch((error) => {
        // console.log(error)
        swal({
          title: `${t(error.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setShowReject(false)
        setBtnLoading(false)
      })
  }

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [files, setFiles] = useState({file: null})
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')
  const [kontrakNum, setKontrakNum] = useState('')
  const [attachmentType, setAttachmentType] = useState('order-item')

  const ambilAttachment = async (id: any, type: any = null) => {
    if(type) setAttachmentType(type)
    await getFile(type || attachmentType, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setShowUpload(true)
    })
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (del) => {
      if (del) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const clearFile = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
  }

  const handleUpload = async () => {
    let file = files.file
    let formdata = new FormData()
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('credentials', localStorage.getItem('credential')!)
    formdata.append('unique_number', kontrakNum)
    formdata.append('private', isPrivate.toString())
    formdata.append('unique_flag', 'new_contract_osd')
    // console.log(formdata)
    setBtnLoading(true)
    await create(attachmentType, formdata)
      .then((res) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setFiles({file: null})
          setIsPrivate(false)
          clearFile()
        })
        ambilAttachment(subOrderID)
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [showJadwal, setShowJadwal] = useState(false)
  const [jadwalID, setJadwalID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [quantumContract, setQuantumContract] = useState('')
  const [tipeProduct, setTipeProduct] = useState('')
  const [unitProduct, setUnitProduct] = useState('')

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }

    setFixedQuantum(temp)
    setQuantumContract(temp)
  }

  const handleShowEndUser = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return <label>{temp}</label>
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  // const [letterData, setletterData] = useState<any>({})
  const [showLetter, setShowLetter] = useState(false)
  const [showLetter2, setShowLetter2] = useState(false)
  const [tempdetailuser, settempdetailuser] = useState<any>(null)
  const [tempfooter, settemfooter] = useState<any>(null)
  const [temp, settemp] = useState<any>([])
  const [tempharga, settempharga] = useState<any>([])
  const [tempquantum, settempquantum] = useState<any>([])
  const [tempspec, settempspec] = useState<any>([])

  const handleOpenn = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('a')) {
      icon?.classList.remove('a')
      icon?.classList.add('b')
    } else {
      icon?.classList.remove('b')
      icon?.classList.add('a')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('foldd-open')
  }

  const LetterData = {
    lang: i18next.language,
      sector: sektorid ? sektorid : '',
      customer: details?.customer?.title
        ? details?.customer?.title + ' ' + details?.customer?.name
        : details?.customer?.name,
      anper: details?.anper?.name,
      address: customerAddress ? customerAddress : '',
      city: tempdetailuser ? tempdetailuser?.city?.city_name : '',
      region: tempdetailuser ? tempdetailuser?.region?.region_name : '',
      customerAttn: i18next.language == 'en' ? (details?.additional_texts?.customer_attn_en || (details?.additional_texts?.customer_attn || '')) : (details?.additional_texts?.customer_attn || ''),
      mail: i18next.language == 'en' ? (details?.additional_texts?.mail_body_en || (details?.additional_texts?.mail_body || '')) : (details?.additional_texts?.mail_body || ''),
      terms: i18next.language == 'en' ? (details?.additional_texts?.terms_and_conditions_en || (details?.additional_texts?.terms_and_conditions || '')) : (details?.additional_texts?.terms_and_conditions || ''),
      title: i18next.language == 'en' ? (details?.additional_texts?.title_en || (details?.additional_texts?.title || '')) : (details?.additional_texts?.title || ''),
      dateFrom: details?.validity_date_from ? details?.validity_date_from.slice(0, 10) : '',
      dateTo: details?.validity_date_to ? details?.validity_date_to.slice(0, 10) : '',
      port: details?.additional_texts?.port_of_discharge ? details?.additional_texts?.port_of_discharge : '',
      lain_lain: i18next.language == 'en' ? (details?.additional_texts?.lain_lain_en || (details?.additional_texts?.lain_lain || '')) : (details?.additional_texts?.lain_lain || ''),
      keterangan: i18next.language == 'en' ? (details?.additional_texts?.keterangan_en || (details?.additional_texts?.keterangan || '')) : (details?.additional_texts?.keterangan || ''),
      textPenutup: i18next.language == 'en' ? (details?.additional_texts?.text_penutup_en || (details?.additional_texts?.text_penutup || '')) : (details?.additional_texts?.text_penutup || ''),
      footerContentId: tempfooter ? tempfooter.indonesia.content : '',
      footerContentEn: tempfooter ? tempfooter.english.content : '',
      subItem: temp ? temp : [],
      signername: details?.assigner_name ? details?.assigner_name : '',
      singerposition: details?.assigner_position ? details?.assigner_position : '',
      cusName: details?.additional_texts?.customer_pic_name ? details?.additional_texts?.customer_pic_name : '',
      cusPos: details?.additional_texts?.customer_pic_position ? details?.additional_texts?.customer_pic_position : '',
      include: details?.doc_is_inc_ppn ?? false,
      payloadharga: tempharga ? tempharga : '',
      payloadquantum: tempquantum ? tempquantum : '',
      payloadspec: tempspec ? tempspec : '',
      imgHeader: imgHeader ? imgHeader?.url_file : '',
      imgFooter: imgFooter ? imgFooter?.url_file : '',
      pph22: details?.amount_of_pph22,
      segment: details?.order_sub_details ? (details?.order_sub_details[0]?.sector_id == '3' ? 'Ekspor' : details?.order_sub_details[0]?.segment_name) : "",
      incoterm1: details?.incoterm?.code,
      incoterm2: details?.incoterm2_id,
      has_amendment: details?.has_amendment,
      sapNumber: details?.sap_number,
      approvedDate: details?.release_date,
  }

  const handleShowPreview = async (_details: any) => {
    setShowLetter(false)
    let _temp: any[] = []
    let _tempquantum: any[] = []
    let _tempharga: any[] = []
    let _tempspec: any[] = []

    _details.order_sub_details.forEach((element: any) => {
      _temp.push(element)
      _tempquantum.push(parseFloat(element.quantum_contract))
      _tempharga.push(parseFloat(element.price_contract))
      _tempspec.push(element.product_spec)
    })

    settemp(_temp)
    settempquantum(_tempquantum)
    settempharga(_tempharga)
    settempspec(_tempspec)

    try{
      await getUserDetail(sektorid || idSektor, _details?.customer?.customer_code).then((res: any) => {
        settempdetailuser(res.data.data)
      })
    }catch(err) { console.log(err) }
    try{
      await getFooterContent(_details?.anper?.code, 'contract').then((res: any) => {
        settemfooter(res.data.data)
      })
    }catch(err) { console.log(err) }
    setShowLetter(true)
  }

  const handleDownloadDraft = async () => {
    try {
      setLoadingDownloadDraft(true)
      const response = await downloadDraft(ContractID, i18next.language);
      const href = URL.createObjectURL(response.data)

      let file_name = `12${kontrakId}_${customerName}_${(i18next.language == 'en' ? '_Letter_of_Confirmation' : '_SKPP')}`

      if ([1,2,3,99].includes(details?.status)) file_name = file_name + '_DRAFT';
      
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', file_name + '.pdf')
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownloadDraft(false)
    } catch (error) {
      setLoadingDownloadDraft(false)
      swal({
        title: t('Donwload Failed'),
        icon: 'error',
      })
    }
  }

  const editAdditionalText = async () => {
    setBtnLoading(true)
    const payload = {
      title: title ? title : '',
      title_en: titleEn ? titleEn : '',
      customer_pic_name: customer_pic_name ? customer_pic_name : '',
      customer_pic_position: customer_pic_position ? customer_pic_position : '',
      terms_and_conditions: terms_and_conditions ? terms_and_conditions : '',
      terms_and_conditions_en: terms_and_conditionsEn ? terms_and_conditionsEn : '',
      mail_body: mail_body ? mail_body : '',
      mail_body_en: mail_bodyEn ? mail_bodyEn : '',
      customer_attn: customer_attn ? customer_attn : '',
      customer_attn_en: customer_attnEn ? customer_attnEn : '',
      port_of_discharge: port_of_discharge ? port_of_discharge : '',
      lain_lain: lain_lain ? lain_lain : '',
      lain_lain_en: lain_lainEn ? lain_lainEn : '',
      keterangan: keterangan ? keterangan : '',
      keterangan_en: keteranganEn ? keteranganEn : '',
      text_penutup: textPenutup ? textPenutup : '',
      text_penutup_en: textPenutupEn ? textPenutupEn : '',
      no_izin_export: noExport ? noExport : '',
      assigner_name: assignerName,
      assigner_position: assignerPos,
    }
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
    }).then(async (accept) => {
      if (accept) {
        await resubmitAdditionalText(params.id, payload).then((res: any) => {
          setBtnLoading(false)
          swal({
            title: `${t('Data Updated Successfully')}`,
            icon: 'success',
          })
            .then(() => {
              // navigate('/management/kontrak')
            })
            .catch((err) => {
              swal({
                title: `${t(err.response.data.message.message)}`,
                icon: 'error',
              }).then(() => {
                setShowAdditional(false)
              })
            })
        })
      }
    })
    setBtnLoading(false)
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {t('page Approval kontrak detail')}
      </PageTitle>
      <div className='card'>
        <div className='card-body'>
          {loading ? (
            <div className='d-flex justify-content-center py-10'>
              <div className='lds-ellipsis'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <>
              <div>
                {/* begin::Header */}
                {
                  showPreviewForm && <>
                  {
                    showLetter ? <>
                      <div style={{padding: '30px', border: '2px dotted #333'}}>
                        <ViewLetter data={LetterData} type='kontrak' />
                      </div>

                      <div className='my-5 d-flex justify-content-end  mt-8 mb-5'>
                        <Button
                          className='me-2'
                          variant='primary'
                          onClick={() => {
                            setShowUpload(true)
                            setAttachmentType('contract')
                            setSubOrderID(ContractID || '')
                            ambilAttachment(ContractID, 'contract')
                          }}
                        >
                          <i className="bi bi-file-earmark-text"></i>
                          {t('order-lampiran')}
                        </Button>
                      </div>

                      <div className='table-responsive mt-5 bdr'>
                      {/* Table Head */}
                      <TableUI.TableDetail colSpan={14}>
                        <TableUI.TableWrapper style={{marginBottom: 0}}>
                          <TableUI.Table>
                            <TableUI.THead>
                              <tr style={{backgroundColor: '#274070'}}>
                                <th>{t('kontrak-item')}</th>
                                <th>Status</th>
                                <th>{t('kontrak-aksi')}</th>
                                <th>Sales Org</th>
                                <th>{t('kontrak-incoterm')} </th>
                                <th>{t('kontrak-wilayah')}</th>
                                {sektorid == 1 && <th>{t('segment')}</th>}
                                <th>{t('sub-order-endUser')}</th>
                                <th>{t('Sector')} </th>
                                <th>{t('kontrak-jenis')} </th>
                                <th>{t('Product Code')} </th>
                                <th>{t('kontrak-nama')} </th>
                                <th>{t('kontrak-spek')}</th>
                                <th>{t('kontrak-kuantum')}</th>
                                <th>{t('Shipping Tolerance')}</th>
                                <th>{t('kontrak-harga')}</th>
                                {/* <th>Price</th> */}
                                <th>{t('kontrak-hargaPPN')}</th>
                                <th>{t('kontrak-ppn')}</th>
                                <th>{t('kontrak-hargaSPPN')}</th>
                                {/* <th>Status {t('Price')}</th> */}
                                {sektorid == 2 ? <th>{t('kontrak-Gudang')} </th> : ''}
                              </tr>
                            </TableUI.THead>
                            <TableUI.TBody>
                              {details != null ? (
                                <>
                                  {details?.order_sub_details?.map((detailss: any, index: number) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <div>{index + 1}</div>
                                        </td>
                                        <td>
                                          <BadgeColorKontrak
                                            status={detailss?.status_contract}
                                            text={detailss?.status_text_contract}
                                            role={roleUser}
                                          />
                                        </td>
                                        <td>
                                          <div>

                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('order-lampiran')}
                                              onClick={() => {
                                                setFileBox(detailss)
                                                setSubOrderID(
                                                  detailss.order_sub_item_id == null
                                                    ? detailss.id
                                                    : detailss.order_sub_item_id
                                                )
                                                setKontrakNum(details.contract_number)
                                                ambilAttachment(
                                                  detailss.order_sub_item_id == null
                                                    ? detailss.id
                                                    : detailss.order_sub_item_id
                                                )
                                                setShowUpload(true)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/archive-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                          </div>
                                        </td>
                                        <td>
                                          <div>{detailss.produsen.name}</div>
                                        </td>
                                        {detailss.incoterm2 != null ? (
                                          <td>
                                            <div>
                                              <PopoverText
                                                content={
                                                  detailss.incoterm1.code +
                                                  '-' +
                                                  detailss.incoterm2.code
                                                }
                                                index={index}
                                                className='spec-sliceee'
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          <>
                                            {detailss.incoterm2_id == null ||
                                            detailss.incoterm2_id == '0' ? (
                                              <td>
                                                <div>{detailss.incoterm1.code}</div>
                                              </td>
                                            ) : (
                                              <td>
                                                <div>
                                                  <PopoverText
                                                    content={
                                                      detailss.incoterm1.code +
                                                      '-' +
                                                      detailss.incoterm2_id
                                                    }
                                                    index={index}
                                                    className='spec-sliceee'
                                                  />
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                detailss['province']?.region_name ||
                                                '' +
                                                  (detailss['city']?.city_name
                                                    ? ', ' + detailss['city']?.city_name
                                                    : '')
                                              }
                                              index={index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                        {sektorid == 1 && (
                                          <td>
                                            <div>{detailss.segment_name}</div>
                                          </td>
                                        )}
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                detailss.end_user_multiple
                                                  ? handleShowValue(detailss.end_user)
                                                  : detailss.end_user
                                              }
                                              index={index}
                                              className='desc-slice'
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div>{t(detailss?.sector?.name)}</div>
                                        </td>
                                        <td>
                                          <div>{detailss?.product_type_desc}</div>
                                        </td>
                                        <td>
                                          <div>
                                            {parseInt(detailss.material_number) == 0
                                              ? ''
                                              : detailss.material_number?.slice(-7)}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{detailss.product_name}</div>
                                        </td>
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={detailss.product_spec || '-'}
                                              index={index}
                                              className='spec-slicee'
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {i18next.language === 'en'
                                              ? parseFloat(detailss.quantum_contract)?.toLocaleString(
                                                  'en',
                                                  {
                                                    maximumFractionDigits: 4,
                                                  }
                                                )
                                              : parseFloat(detailss.quantum_contract)?.toLocaleString(
                                                  'id',
                                                  {
                                                    maximumFractionDigits: 4,
                                                  }
                                                )}{' '}
                                            {detailss.product_type_desc == 'KANTONG/SACK'
                                              ? detailss.unit
                                              : detailss?.sector_id == 3
                                              ? 'MT'
                                              : 'Ton'}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{detailss.shipping_tolerance_contract}%</div>
                                        </td>
                                        {/* <td>
                                  {detailss.request_price.toLocaleString()}/1
                                </td> */}
                                        <td>
                                          <div>
                                            {(detailss.sector_id == 3 ? 'USD' : 'Rp') +
                                              (i18next.language === 'en'
                                                ? parseFloat(detailss.price_contract)?.toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  )
                                                : parseFloat(detailss.price_contract)?.toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ))}
                                            /
                                            {detailss.product_type_desc == 'KANTONG/SACK'
                                              ? detailss.unit
                                              : detailss.sector_id == 3
                                              ? 'MT'
                                              : 'Ton'}
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {(detailss.sector_id == 3 ? 'USD' : 'Rp') +
                                              (i18next.language === 'en'
                                                ? parseFloat(detailss.price_before_ppn)?.toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  )
                                                : parseFloat(detailss.price_before_ppn)?.toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ))}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{detailss?.ppn}%</div>
                                        </td>
                                        <td>
                                          <div>
                                            {(detailss.sector_id == 3 ? 'USD' : 'Rp') +
                                              (i18next.language === 'en'
                                                ? parseFloat(detailss.price_after_ppn)?.toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  )
                                                : parseFloat(detailss.price_after_ppn)?.toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ))}
                                          </div>
                                        </td>
                                        {detailss?.sector_id == 2 && (
                                          <td>
                                            <div>{detailss?.plant_desc}</div>
                                          </td>
                                        )}
                                      </tr>
                                    )
                                  })}
                                </>
                              ) : null}
                            </TableUI.TBody>
                          </TableUI.Table>
                        </TableUI.TableWrapper>
                      </TableUI.TableDetail>
                      {/* End Table Head */}
                    </div>

                    </> : <>
                    <div className='d-flex justify-content-center py-10'>
                      <div className='lds-ellipsis'>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    </>
                  }
                  </>
                }
                {
                  !showPreviewForm && <>
                    <Row>
                      <Col lg={6}>
                        <Row className='mb-4 mt-4'>
                          <Col lg={5}>
                            <p className='fs-4'>Status</p>
                          </Col>
                          <Col lg={7}>
                            <span className='d-block '>
                              <span className='badge badge-light-primary'>
                                <BadgeColorKontrak
                                  status={details?.status}
                                  text={details?.status_text}
                                  role={roleUser}
                                />
                              </span>
                            </span>
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-3'>{t('kontrak-kontrakID')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder='ID-22912'
                              value={details?.id}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control type='text' value={customerCode} disabled size='sm' />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>Incoterm</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder='Incoterm'
                              value={details?.incoterm1?.code}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>{t('negara')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              value={details?.country_destination}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('Sales Office')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={details?.sales_office_detail?.region_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>{t('order-tanggal-dari')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder={t('order-tanggal-dari')}
                              value={dateformat(dateFrom)}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col className='d-flex align-items-center' lg={5}>
                            <p className='fs-4'>{t('Assigner Name')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder={t('Assigner Name')}
                              value={details?.assigner_name}
                              disabled={!stateApproval}
                              onChange={(e: any) => {
                                setassignerName(e?.target?.value)
                              }}
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>{t('Ship To')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control type='text' value={customerShip} disabled size='sm' />
                          </Col>
                        </Row>
                      </Col>
                      <Col md={6}>
                        <Row className='mb-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('Address')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              as='textarea'
                              value={customerAddress}
                              disabled
                              size='sm'
                              style={{height: '40px'}}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-3'>{t('sip-number')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder='SIP-22912'
                              value={
                                details?.sip_order?.SIP_number
                                  ? 'SIP' + details?.sip_order?.SIP_number
                                  : ''
                              }
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control type='text' value={customerName} disabled size='sm' />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>Incoterm2</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder='Incoterm2'
                              value={details?.incoterm2_id}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>{t('provinsi-tujuan')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              value={details?.province_desc}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col md={5}>
                            <p className='fs-4 mt-2'>{t('Sales Group')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={details?.sales_group_detail?.city_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>{t('order-tanggal-berakhir')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder={t('order-tanggal-berakhir')}
                              value={dateformat(dateTo)}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col className='d-flex align-items-center' lg={5}>
                            <p className='fs-4'>{t('Assigner Position')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              placeholder={t('Assigner Name')}
                              value={details?.assigner_position}
                              disabled={!stateApproval}
                              onChange={(e: any) => {
                                setassignerPos(e?.target?.value)
                              }}
                              size='sm'
                            />
                          </Col>
                        </Row>
                        {/* <Row className='mb-3'>
                          <Col lg={5}>
                            <p className='fs-4 mt-2'>{t('nomorIzinExport')}</p>
                          </Col>
                          <Col lg={7}>
                            <Form.Control
                              type='text'
                              value={details?.no_izin_export}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row> */}
                      </Col>
                    </Row>

                    <hr />

                    <div className='my-5 d-flex justify-content-end  mt-8 mb-5'>
                      <Button
                        className='me-2'
                        variant='primary'
                        onClick={() => {
                          setShowUpload(true)
                          setAttachmentType('contract')
                          setSubOrderID(ContractID || '')
                          ambilAttachment(ContractID, 'contract')
                        }}
                      >
                        <i className="bi bi-file-earmark-text"></i>
                        {t('order-lampiran')}
                      </Button>
                      <Button
                          onClick={() => {
                            setShowLetter2(true)
                          }}
                          className='btn btn-primary fw-semibold d-flex align-items-center me-2'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('preview')}
                        >
                          <i className="fa fa-eye"></i>
                          {t('preview')}
                      </Button>
                      <Modal
                        show={showLetter2}
                        onHide={() => setShowLetter2(false)}
                        size='xl'
                        backdrop='static'
                        keyboard={false}
                        scrollable
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('preview')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <ViewLetter data={LetterData} type='kontrak' />
                        </Modal.Body>
                      </Modal>
                      
                      {
                        hakAkses?.update && <>
                          <button
                            className='btn btn-primary'
                            onClick={() => setShowAdditional(true)}
                          >
                            <i className='fas fa-bars'></i> {t('addtional')} {t('text')}
                          </button>
                          <Modal
                            show={showAdditional}
                            onHide={() => setShowAdditional(false)}
                            size='lg'
                            centered
                            backdrop='static'
                            keyboard={false}
                            scrollable
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>
                                {t('addtional')} {t('text')}
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
      
                              <div className="d-flex justify-content-end mb-3">
                                <div style={{ maxWidth: 140 }} className='btn-lang d-flex'>
                                  <button
                                    className={'d-flex align-items-center me-1 ' + (addTextLanguage == 'id' ? 'active' : '')}
                                    onClick={() => setAddTextLanguage('id')}
                                  >
                                    <h6 className='ms-1'>Ind</h6>
                                  </button>
                                  <button
                                    className={'d-flex align-items-center me-1 ' + (addTextLanguage == 'en' ? 'active' : '')}
                                    onClick={() => setAddTextLanguage('en')}
                                  >
                                    <h6 className='ms-1'>Eng</h6>
                                  </button>
                                </div>
                              </div>
      
      
                              {addTextLanguage == 'id' && <div>
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'Judul'}
                                      onClick={handleOpenn}
                                      id='titlee'
                                    >
                                      <div className='text-light'>{t('Judul')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'Judul'}>
                                    <Form.Control
                                      className='mt-3'
                                      aria-label='Default select example'
                                      onChange={(e: any) => setTitle(e.target.value)}
                                      placeholder={t('Judul')}
                                      defaultValue={title}
                                    />
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('Judul', setTitle, title_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'nama'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('customer pic name')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'nama'}>
                                    <Form.Control
                                      className='mt-3'
                                      aria-label='Default select example'
                                      onChange={(e: any) => setCustomer_pic_name(e.target.value)}
                                      placeholder={t('customer pic name')}
                                      defaultValue={customer_pic_name}
                                    />
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('nama', setCustomer_pic_name, customer_pic_name_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'Position'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('customer pic position')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'Position'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={customer_pic_position}
                                      onUpdate={({ editor }) => {
                                        setCustomer_pic_position(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('Position', setCustomer_pic_position, customer_pic_position_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'terms_and_conditions'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('terms_and_conditions')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'terms_and_conditions'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={terms_and_conditions}
                                      onUpdate={({ editor }) => {
                                        setTerms_and_conditions(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('terms_and_conditions', setTerms_and_conditions, terms_and_conditions_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'mail_body'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('mail_body')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'mail_body'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={mail_body}
                                      onUpdate={({ editor }) => {
                                        setMail_body(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('mail_body', setMail_body, mail_body_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'customer_attn'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('customer_attn')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'customer_attn'}>
                                    <Form.Control
                                      className='mt-3'
                                      aria-label='Default select example'
                                      onChange={(e: any) => setCustomer_attn(e.target.value)}
                                      placeholder={t('customer_attn')}
                                      defaultValue={customer_attn}
                                    />
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer_attn', setCustomer_attn, customer_attn_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'port_of_discharge'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('Tujuan')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'port_of_discharge'}>
                                    <Form.Control
                                      className='mt-3'
                                      aria-label='Default select example'
                                      onChange={(e: any) => setPort_of_discharge(e.target.value)}
                                      placeholder={t('Tujuan')}
                                      defaultValue={port_of_discharge}
                                    />
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port_of_discharge', setPort_of_discharge, port_of_discharge_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'other'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('other')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'other'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={lain_lain}
                                      onUpdate={({ editor }) => {
                                        setLain_lain(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('other', setLain_lain, lain_lain_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'order-keterangan'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('order-keterangan')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'order-keterangan'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={keterangan}
                                      onUpdate={({ editor }) => {
                                        setKeterangan(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('order-keterangan', setKeterangan, keterangan_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'textPenutup'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('textPenutup')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'textPenutup'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={textPenutup}
                                      onUpdate={({ editor }) => {
                                        setTextPenutup(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('textPenutup', setTextPenutup, textPenutup_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'nomor export'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('nomorIzinExport')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'nomor export'}>
                                    <Form.Control
                                      className='mt-3'
                                      as='textarea'
                                      //maxLength={132}
                                      aria-label='Default select example'
                                      onChange={(e: any) => setNoExport(e.target.value)}
                                      placeholder={t('nomorIzinExport')}
                                      defaultValue={noExport}
                                    />
                                    {/* <div className="d-flex justify-content-end">
                                <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('nomor export', setNoExport, noExport_)}>{t('Save')}</button>
                              </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
                              </div>}
                              {addTextLanguage == 'en' && <div>
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'Judul'}
                                      onClick={handleOpenn}
                                      id='titlee'
                                    >
                                      <div className='text-light'>{t('Judul')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'Judul'}>
                                    <Form.Control
                                      className='mt-3'
                                      aria-label='Default select example'
                                      onChange={(e: any) => setTitleEn(e.target.value)}
                                      placeholder={t('Judul')}
                                      defaultValue={titleEn}
                                    />
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('Judul', setTitle, title_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'terms_and_conditions'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('terms_and_conditions')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'terms_and_conditions'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={terms_and_conditionsEn}
                                      onUpdate={({ editor }) => {
                                        setTerms_and_conditionsEn(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('terms_and_conditions', setTerms_and_conditions, terms_and_conditions_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'mail_body'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('mail_body')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'mail_body'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={mail_bodyEn}
                                      onUpdate={({ editor }) => {
                                        setMail_bodyEn(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('mail_body', setMail_body, mail_body_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'customer_attn'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('customer_attn')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'customer_attn'}>
                                    <Form.Control
                                      className='mt-3'
                                      aria-label='Default select example'
                                      onChange={(e: any) => setCustomer_attnEn(e.target.value)}
                                      placeholder={t('customer_attn')}
                                      defaultValue={customer_attnEn}
                                    />
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer_attn', setCustomer_attn, customer_attn_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'other'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('other')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'other'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={lain_lainEn}
                                      onUpdate={({ editor }) => {
                                        setLain_lainEn(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('other', setLain_lain, lain_lain_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'order-keterangan'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('order-keterangan')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'order-keterangan'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={keteranganEn}
                                      onUpdate={({ editor }) => {
                                        setKeteranganEn(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('order-keterangan', setKeterangan, keterangan_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
      
                                <Form.Group className='mb-3' controlId='formBasicEmail'>
                                  <div className='d-flex align-items-center'>
                                    <button
                                      className='a btn btn-primary w-100'
                                      data-target={'target' + 'textPenutup'}
                                      onClick={handleOpenn}
                                    >
                                      <div className='text-light'>{t('textPenutup')}</div>
                                    </button>
                                  </div>
                                  <div className='fold' id={'target' + 'textPenutup'}>
                                    <RichText
                                      containerClassName='mt-4'
                                      content={textPenutupEn}
                                      onUpdate={({ editor }) => {
                                        setTextPenutupEn(editor.getHTML())
                                      }}
                                    >
                                      &nbsp;
                                    </RichText>
                                    {/* <div className='d-flex justify-content-end'>
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('textPenutup', setTextPenutup, textPenutup_)}>
                                {t('Save')}
                              </button>
                            </div> */}
                                  </div>
                                </Form.Group>
                                <hr />
                              </div>}
      
                              <div className='d-flex justify-content-end mt-5'></div>
                            </Modal.Body>
                          </Modal>
                        </>
                      }
                    </div>

                    <div className='table-responsive mt-5 bdr'>
                      {/* Table Head */}
                      <TableUI.TableDetail colSpan={14}>
                        <TableUI.TableWrapper style={{marginBottom: 0}}>
                          <TableUI.Table>
                            <TableUI.THead>
                              <tr style={{backgroundColor: '#274070'}}>
                                <th>{t('kontrak-item')}</th>
                                <th>Status</th>
                                <th>{t('kontrak-aksi')}</th>
                                <th>Sales Org</th>
                                <th>{t('kontrak-incoterm')} </th>
                                <th>{t('kontrak-wilayah')}</th>
                                {sektorid == 1 && <th>{t('segment')}</th>}
                                <th>{t('sub-order-endUser')}</th>
                                <th>{t('Sector')} </th>
                                <th>{t('kontrak-jenis')} </th>
                                <th>{t('Product Code')} </th>
                                <th>{t('kontrak-nama')} </th>
                                <th>{t('kontrak-spek')}</th>
                                <th>{t('kontrak-kuantum')}</th>
                                <th>{t('Shipping Tolerance')}</th>
                                <th>{t('kontrak-harga')}</th>
                                {/* <th>Price</th> */}
                                <th>{t('kontrak-hargaPPN')}</th>
                                <th>{t('kontrak-ppn')}</th>
                                <th>{t('kontrak-hargaSPPN')}</th>
                                {/* <th>Status {t('Price')}</th> */}
                                {sektorid == 2 ? <th>{t('kontrak-Gudang')} </th> : ''}
                              </tr>
                            </TableUI.THead>
                            <TableUI.TBody>
                              {details != null ? (
                                <>
                                  {details?.order_sub_details?.map((detailss: any, index: number) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <div>{index + 1}</div>
                                        </td>
                                        <td>
                                          <BadgeColorKontrak
                                            status={detailss?.status_contract}
                                            text={detailss?.status_text_contract}
                                            role={roleUser}
                                          />
                                        </td>
                                        <td>
                                          <div>
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title='Detail'
                                              onClick={() => handleDetail(detailss)}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/file-text-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>

                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('order-lampiran')}
                                              onClick={() => {
                                                setFileBox(detailss)
                                                setSubOrderID(
                                                  detailss.order_sub_item_id == null
                                                    ? detailss.id
                                                    : detailss.order_sub_item_id
                                                )
                                                setKontrakNum(details.contract_number)
                                                ambilAttachment(
                                                  detailss.order_sub_item_id == null
                                                    ? detailss.id
                                                    : detailss.order_sub_item_id
                                                )
                                                setShowUpload(true)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/archive-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                            <button
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                              data-bs-toggle='tooltip'
                                              data-bs-placement='top'
                                              data-bs-trigger='hover'
                                              title={t('Jadwal')}
                                              onClick={() => {
                                                setIDSector(detailss.sector_id)
                                                setProvinceName(detailss.province?.region_name)
                                                setCityName(detailss.city?.city_name)
                                                setProductName(detailss.product_name)
                                                formattingTon(detailss.quantum_contract)
                                                setJadwalID(
                                                  detailss.order_sub_item_id == null
                                                    ? detailss.id
                                                    : detailss.order_sub_item_id
                                                )
                                                setTipeProduct(detailss.product_type)
                                                setUnitProduct(detailss.unit)
                                                setShowJadwal(true)
                                              }}
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/calendar-check-fill.svg'
                                                className='svg-icon-3'
                                              />
                                            </button>
                                          </div>
                                        </td>
                                        <td>
                                          <div>{detailss.produsen.name}</div>
                                        </td>
                                        {detailss.incoterm2 != null ? (
                                          <td>
                                            <div>
                                              <PopoverText
                                                content={
                                                  detailss.incoterm1.code +
                                                  '-' +
                                                  detailss.incoterm2.code
                                                }
                                                index={index}
                                                className='spec-sliceee'
                                              />
                                            </div>
                                          </td>
                                        ) : (
                                          <>
                                            {detailss.incoterm2_id == null ||
                                            detailss.incoterm2_id == '0' ? (
                                              <td>
                                                <div>{detailss.incoterm1.code}</div>
                                              </td>
                                            ) : (
                                              <td>
                                                <div>
                                                  <PopoverText
                                                    content={
                                                      detailss.incoterm1.code +
                                                      '-' +
                                                      detailss.incoterm2_id
                                                    }
                                                    index={index}
                                                    className='spec-sliceee'
                                                  />
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                detailss['province']?.region_name ||
                                                '' +
                                                  (detailss['city']?.city_name
                                                    ? ', ' + detailss['city']?.city_name
                                                    : '')
                                              }
                                              index={index}
                                              className='spec-sliceee'
                                            />
                                          </div>
                                        </td>
                                        {sektorid == 1 && (
                                          <td>
                                            <div>{detailss.segment_name}</div>
                                          </td>
                                        )}
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={
                                                detailss.end_user_multiple
                                                  ? handleShowValue(detailss.end_user)
                                                  : detailss.end_user
                                              }
                                              index={index}
                                              className='desc-slice'
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div>{t(detailss?.sector?.name)}</div>
                                        </td>
                                        <td>
                                          <div>{detailss?.product_type_desc}</div>
                                        </td>
                                        <td>
                                          <div>
                                            {parseInt(detailss.material_number) == 0
                                              ? ''
                                              : detailss.material_number?.slice(-7)}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{detailss.product_name}</div>
                                        </td>
                                        <td>
                                          <div>
                                            <PopoverText
                                              content={detailss.product_spec || '-'}
                                              index={index}
                                              className='spec-slicee'
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {i18next.language === 'en'
                                              ? parseFloat(detailss.quantum_contract)?.toLocaleString(
                                                  'en',
                                                  {
                                                    maximumFractionDigits: 4,
                                                  }
                                                )
                                              : parseFloat(detailss.quantum_contract)?.toLocaleString(
                                                  'id',
                                                  {
                                                    maximumFractionDigits: 4,
                                                  }
                                                )}{' '}
                                            {detailss.product_type_desc == 'KANTONG/SACK'
                                              ? detailss.unit
                                              : detailss?.sector_id == 3
                                              ? 'MT'
                                              : 'Ton'}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{detailss.shipping_tolerance_contract}%</div>
                                        </td>
                                        {/* <td>
                                  {detailss.request_price.toLocaleString()}/1
                                </td> */}
                                        <td>
                                          <div>
                                            {(detailss.sector_id == 3 ? 'USD' : 'Rp') +
                                              (i18next.language === 'en'
                                                ? parseFloat(detailss.price_contract)?.toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  )
                                                : parseFloat(detailss.price_contract)?.toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ))}
                                            /
                                            {detailss.product_type_desc == 'KANTONG/SACK'
                                              ? detailss.unit
                                              : detailss.sector_id == 3
                                              ? 'MT'
                                              : 'Ton'}
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            {(detailss.sector_id == 3 ? 'USD' : 'Rp') +
                                              (i18next.language === 'en'
                                                ? parseFloat(detailss.price_before_ppn)?.toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  )
                                                : parseFloat(detailss.price_before_ppn)?.toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ))}
                                          </div>
                                        </td>
                                        <td>
                                          <div>{detailss?.ppn}%</div>
                                        </td>
                                        <td>
                                          <div>
                                            {(detailss.sector_id == 3 ? 'USD' : 'Rp') +
                                              (i18next.language === 'en'
                                                ? parseFloat(detailss.price_after_ppn)?.toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  )
                                                : parseFloat(detailss.price_after_ppn)?.toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ))}
                                          </div>
                                        </td>
                                        {detailss?.sector_id == 2 && (
                                          <td>
                                            <div>{detailss?.plant_desc}</div>
                                          </td>
                                        )}
                                      </tr>
                                    )
                                  })}
                                </>
                              ) : null}
                            </TableUI.TBody>
                          </TableUI.Table>
                        </TableUI.TableWrapper>
                      </TableUI.TableDetail>
                      {/* End Table Head */}
                    </div>

                    <div style={{width: '50%'}}>
                      <Row className='mb-3'>
                        <Col lg={5}>
                          <p className='fs-4 mt-3'>Total {t('kontrak-kuantum')}</p>
                        </Col>
                        <Col lg={7}>
                          {details != null ? (
                            <Form.Control
                              type='text'
                              placeholder={'Total ' + t('kontrak-kuantum')}
                              value={
                                i18next.language === 'en'
                                  ? quantumApprove.toLocaleString('en', {maximumFractionDigits: 4}) +
                                    ' ' +
                                    'Ton'
                                  : quantumApprove.toLocaleString('id', {maximumFractionDigits: 4}) +
                                    ' ' +
                                    'Ton'
                              }
                              disabled
                            />
                          ) : (
                            <Form.Control
                              type='text'
                              placeholder={'Total ' + t('kontrak-kuantum')}
                              disabled
                            />
                          )}
                        </Col>
                      </Row>

                      {kantongApprove ? (
                        <>
                          <Row className='mb-3'>
                            <Col lg={5}>
                              <p className='fs-4 mt-3'>Total {t('sack')}</p>
                            </Col>
                            <Col lg={7}>
                              {details != null && kantongApprove != 0 ? (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('sack')}
                                  value={
                                    i18next.language === 'en'
                                      ? kantongApprove.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) +
                                        ' ' +
                                        punit
                                      : kantongApprove.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) +
                                        ' ' +
                                        punit
                                  }
                                  disabled
                                />
                              ) : (
                                <Form.Control type='text' placeholder={'Total ' + t('sack')} disabled />
                              )}
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <></>
                      )}

                      {sektorid != 3 ? (
                        <>
                          <Row className='mb-3'>
                            <Col lg={5}>
                              <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                            </Col>
                            <Col lg={7}>
                              {details != null ? (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('Exclude') + ' PPN'}
                                  value={
                                    'Rp' +
                                    (i18next.language === 'en'
                                      ? beforePpn.toLocaleString('en', {maximumFractionDigits: 4})
                                      : beforePpn.toLocaleString('id', {maximumFractionDigits: 4}))
                                  }
                                  disabled
                                />
                              ) : (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('Exclude') + ' PPN'}
                                  disabled
                                />
                              )}
                            </Col>
                          </Row>

                          <Row className='mb-3'>
                            <Col lg={5}>
                              <p className='fs-4 mt-3'>Total {t('Include')} PPN</p>
                            </Col>
                            <Col lg={7}>
                              {details != null ? (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('Include') + ' PPN'}
                                  value={
                                    'Rp' +
                                    (i18next.language === 'en'
                                      ? fixedPrice.toLocaleString('en', {maximumFractionDigits: 4})
                                      : fixedPrice.toLocaleString('id', {maximumFractionDigits: 4}))
                                  }
                                  disabled
                                />
                              ) : (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('Include') + ' PPN'}
                                  disabled
                                />
                              )}
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row className='mb-3'>
                            <Col lg={5}>
                              <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                            </Col>
                            <Col lg={7}>
                              {details != null ? (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('Exclude') + ' PPN'}
                                  value={
                                    i18next.language === 'en'
                                      ? 'USD' +
                                        beforePpn.toLocaleString('en', {maximumFractionDigits: 4})
                                      : 'USD' +
                                        beforePpn.toLocaleString('id', {maximumFractionDigits: 4})
                                  }
                                  disabled
                                />
                              ) : (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('Exclude') + ' PPN'}
                                  disabled
                                />
                              )}
                            </Col>
                          </Row>

                          <Row className='mb-3'>
                            <Col lg={5}>
                              <p className='fs-4 mt-3'>Total {t('Include')} PPN</p>
                            </Col>
                            <Col lg={7}>
                              {details != null ? (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('Include') + ' PPN'}
                                  value={
                                    i18next.language === 'en'
                                      ? 'USD' +
                                        fixedPrice.toLocaleString('en', {maximumFractionDigits: 4})
                                      : 'USD' +
                                        fixedPrice.toLocaleString('id', {maximumFractionDigits: 4})
                                  }
                                  disabled
                                />
                              ) : (
                                <Form.Control
                                  type='text'
                                  placeholder={'Total ' + t('Include') + ' PPN'}
                                  disabled
                                />
                              )}
                            </Col>
                          </Row>
                        </>
                      )}

                      <hr/>
                    </div>
                  </>
                }

                <div className='mt-8 '>
                  <div className='mb-3 mb-md-0 d-flex justify-content-between'>
                    <div>
                      <Button className='btn btn-secondary me-1'
                      onClick={() => {
                        if(showPreviewForm){
                          navigate('/approval/contract')
                        }else{
                          setShowPreviewForm(true)
                        }
                      }}>
                        <i className="bi bi-chevron-left"></i>
                        {t('cancela')}
                      </Button>
                      { showPreviewForm && 
                      <Button
                        variant='warning'
                        className='ml-2'
                        onClick={() => setShowPreviewForm(false)}
                        disabled={btnLoading}
                      >
                        <i className="fa fa-eye"></i>
                        {t('Detail')}
                      </Button> }
                      <Button
                        disabled={loadingDownloadDraft}
                        variant='primary'
                        className='ms-2'
                        onClick={handleDownloadDraft}
                      >
                        {
                          loadingDownloadDraft ? <i className='fa fa-spin fa-spinner'></i> : <>
                            <i className='fa fa-download'></i>
                            {[1,2,3,99].includes(details?.status) ? t('download-sip') : t('download-skpp')}
                          </>
                        }
                      </Button>
                    </div>
                    <div>
                      {stateApproval && showPreviewForm ? (
                        <>
                        {!temporarry_status && (
                          <>
                            <Button
                              className='btn btn-danger me-1'
                              onClick={() => setShowReject(true)}
                              disabled={btnLoading}
                            >
                              <i className="fa fa-times"></i>
                              {t('order-tolak')}
                            </Button>
                          </>
                        )}
                          <Modal show={show3} onHide={handleClose3} centered backdrop='static'>
                            <Modal.Header closeButton>
                              <Modal.Title>{t('order-alasanTolak')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <FloatingLabel controlId='floatingTextarea2' label='Alasan'>
                                <Form.Control
                                  as='textarea'
                                  placeholder={t('Tinggal-pesan')}
                                  style={{height: '100px'}}
                                  onChange={(e: any) => setRevisionNote(e.target.value)}
                                />
                              </FloatingLabel>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant='secondary' onClick={handleClose3}>
                                {t('Tidak')}
                              </Button>
                              <Button variant='warning' onClick={handleRevisi} disabled={btnLoading}>
                                {btnLoading ? (
                                  <Spinner animation='border' variant='light' size='sm' />
                                ) : (
                                  <>{t('Ya')}</>
                                )}
                              </Button>
                            </Modal.Footer>
                          </Modal>
                          <Button
                              className='btn btn-warning me-1'
                              onClick={() => setShowRevision(true)}
                            >
                              <i className="fa fa-edit"></i>
                              {t('order-revisi')}
                            </Button>
                          <Button
                            className='btn btn-success me-1'
                            onClick={() => setShowApprove(true)}
                            disabled={btnLoading}
                          >
                            <i className="fa fa-check"></i>
                            {t('setujui')}
                          </Button>
                          <Modal
                            show={showApprove}
                            onHide={() => setShowApprove(false)}
                            centered
                            backdrop='static'
                          >
                            <Modal.Header closeButton></Modal.Header>
                            <Modal.Body>
                              <h3 className='text-center mb-5'>{t('Approve')}?</h3>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant='secondary' onClick={() => setShowApprove(false)}>
                                {t('Tidak')}
                              </Button>
                              <Button variant='success' onClick={handleApprove} disabled={btnLoading}>
                                {btnLoading ? (
                                  <Spinner animation='border' variant='light' size='sm' />
                                ) : (
                                  t('Ya')
                                )}
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </>
                      ) : (
                        (stateApproval && hakAkses?.update) && <>
                          <Button
                            className='btn btn-warning me-2'
                            onClick={() => editAdditionalText()}
                            disabled={btnLoading}
                          >
                            {btnLoading ? (
                              <Spinner animation='border' variant='light' size='sm' />
                            ) : (
                              <>
                                <i className='fas fa-pencil'></i> Update
                              </>
                            )}
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Modal
                size='lg'
                show={showUpload}
                onHide={() => {
                  setShowUpload(false)
                  setFileBox({})
                }}
                backdrop='static'
                keyboard={false}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {attachmentType == 'order-item' ? (fileBox?.product_name
                      ? (fileBox.province ? fileBox.province?.region_name : '') +
                        (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                        (fileBox.province ? ' | ' : '') +
                        fileBox.product_name +
                        (fileBox.quantum_contract ? ' | ' + fileBox.quantum_contract + ' Ton' : '')
                      : t('File Box')) : <span>{t('File Box')}</span>}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col sm={6}>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-fileUnggah')}</h6>
                          </td>
                          <td className='w-75'>
                            <InputFile
                              setFileName={setNamaFile}
                              setFiles={setFiles}
                              isBase64={false}/>
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-keterangan')}</h6>
                          </td>
                          <td className='w-75'>
                            <Form.Control
                              type='text'
                              placeholder={t('order-keterangan')}
                              onChange={(e: any) => setDescription(e.target.value)}
                              value={description}
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td>
                            <h6 className='me-11'>{t('Private')}</h6>
                          </td>
                          <td className='w-75 d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='isPrivate'
                              type='checkbox'
                              className='mt-5 mb-2'
                              onClick={() => {
                                setIsPrivate(!isPrivate)
                              }}
                              id='isPrivate'
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3' hidden={isPrivate ? false : true}>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('Akses Role')}</h6>
                          </td>
                          <td className='w-75' style={{maxWidth: '274px'}}>
                            <MultiSelect
                              key={isPrivate.toString()}
                              options={fullRole?.map((item: any) => {
                                return {label: item.label, value: item.value}
                              })}
                              value={tempRole}
                              onChange={(e: any) => setTempRole(e)}
                              labelledBy='Select'
                            />
                          </td>
                        </tr>
                      </table>
                      <div className='d-flex justify-content-end'>
                        <Button
                          variant='primary'
                          className='w-100'
                          onClick={() => handleUpload()}
                          disabled={btnLoading}
                        >
                          {btnLoading ? (
                            <Spinner animation='border' variant='light' size='sm' />
                          ) : (
                            t('order-kirim')
                          )}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <div className='table-responsive mt-4 bdr'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead className='fw-bold border-bottom'>
                        <tr className=''>
                          <th className='text-center'>{t('order-noo')}</th>
                          {idSektor == 2 ? (
                            <>
                              <th className='text-center'>{t('order-namaFile')}</th>
                              <th className='text-center'>{t('order-jenisFile')}</th>
                            </>
                          ) : (
                            ''
                          )}
                          <th className='text-center'>{t('order-keterangan')}</th>
                          <th className='text-center'>{t('order-tglUpload')}</th>
                          {/* <th className='text-center'>{t('User Code')}</th> */}
                          <th className='text-center'>{t('order-user')}</th>
                          <th className='text-center'>{t('order-aksi')}</th>
                        </tr>
                      </thead>
                      {allFiles.map((data: any, _index: number) => (
                        <tbody key={data?.name ?? _index}>
                          <tr className=''>
                            <td className='text-center'>
                              <label>{_index + 1}</label>
                            </td>
                            {idSektor == 2 ? (
                              <>
                                <td className='text-center'>
                                  <label>{data.name}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{t(data.file_type)}</label>
                                </td>
                              </>
                            ) : (
                              ''
                            )}
                            <td className='text-center'>
                              <label>{data.description}</label>
                            </td>
                            <td className='text-center'>
                              <label>{dateformat(data.updated_at)}</label>
                            </td>
                            {/* <td className='text-center'>
                              <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                            </td> */}
                            <td className='text-center'>
                              {data.user?.customer_code == null ? (
                                <label>{data.user?.name}</label>
                              ) : (
                                <label>{data.user?.customer?.name}</label>
                              )}
                            </td>
                            <td className='text-center'>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('unduh')}
                                onClick={() =>
                                  handleDownloadAttachment(
                                    data.file_path
                                  )
                                }
                              >
                                <KTSVG
                                  path='/media/icons/duotune/arrow-down-square-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                              {(hakAkses?.attachment_delete ||
                                CheckSameIDAttachment(data.user_role_flag)) && (
                                <button
                                  onClick={() => deleteAttachment(data.id)}
                                  className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Hapus')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/trash-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>
                </Modal.Body>
              </Modal>

              <Modal
                show={show}
                onHide={handleClose}
                centered
                scrollable
                size='xl'
                backdrop='static'
              >
                <Modal.Header closeButton>
                  <Modal.Title>Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {kontrakDetail?.sector_id == 1 && (
                    <Row>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>Sales Org</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.incoterm1?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={kontrakDetail?.province?.region_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.product_type_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('Plant')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.plant_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>
                              {kontrakDetail?.product_type_desc == 'KANTONG/SACK'
                                ? t('sack')
                                : t('Quantum')}
                            </p>
                          </Col>
                          <Col md={7}>
                            {kontrakDetail?.product_type_desc == 'KANTONG/SACK' ? (
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'en',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      ) + ' EA'
                                    : parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'id',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      ) + ' EA'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={
                                  (i18next.language === 'en'
                                    ? parseFloat(kontrakDetail?.quantum_contract).toLocaleString(
                                        'en',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      )
                                    : parseFloat(kontrakDetail?.quantum_contract).toLocaleString(
                                        'id',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      )) + (kontrakDetail?.sector_id == 3 ? ' MT' : ' Ton')
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={5}>
                            <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={7}>
                            <Form.Control
                              size='sm'
                              type='text'
                              id='shipping'
                              value={
                                kontrakDetail?.shipping_tolerance_contract !== '0'
                                  ? kontrakDetail?.shipping_tolerance_contract + '%'
                                  : ''
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_type_1_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('keterangan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_note}
                              as='textarea'
                              disabled
                              size='sm'
                              style={{height: '40px'}}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={
                                kontrakDetail.end_user_multiple
                                  ? handleShowValue(kontrakDetail.end_user)
                                  : kontrakDetail.end_user
                                // kontrakDetail?.end_user_detail?.name
                                //   ? kontrakDetail?.end_user_detail?.name
                                //   : kontrakDetail?.end_user
                              }
                              as='textarea'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={t(kontrakDetail?.sector?.name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={7}>
                            {kontrakDetail?.incoterm2 == null ? (
                              <Form.Control
                                value={
                                  kontrakDetail?.incoterm2_id == null ||
                                  kontrakDetail?.incoterm2_id == '0'
                                    ? ''
                                    : kontrakDetail?.incoterm2_id
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={kontrakDetail?.incoterm2?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={kontrakDetail?.city?.city_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.product_name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={7}>
                            <FieldProductSpec data={kontrakDetail?.product_spec} type='editor' />
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>
                              {t('sub-order-hargaD')}/
                              {kontrakDetail?.product_type_desc == 'KANTONG/SACK'
                                ? kontrakDetail.unit
                                : kontrakDetail?.sector_id == 3
                                ? ' MT'
                                : ' Ton'}
                            </p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? parseInt(kontrakDetail?.price_contract).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : parseInt(kontrakDetail?.price_contract).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-5'>
                          <Col sm={5}>
                            <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                          </Col>
                          <Col sm={7} className='d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='ppn'
                              className='mt-4 mb-2'
                              type='checkbox'
                              id='ckbox-ppn'
                              checked={kontrakDetail?.include_ppn}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_type_2_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('segment')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={t(kontrakDetail?.segment_name)}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.notes}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {kontrakDetail?.sector_id == 2 && (
                    <Row>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>Sales Org</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.incoterm1?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={kontrakDetail?.province?.region_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.plant_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.product_name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>
                              {kontrakDetail?.product_type_desc == 'KANTONG/SACK'
                                ? t('sack')
                                : t('Quantum')}
                            </p>
                          </Col>
                          <Col md={7}>
                            {kontrakDetail?.product_type_desc == 'KANTONG/SACK' ? (
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'en',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      ) + ' EA'
                                    : parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'id',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      ) + ' EA'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={
                                  (i18next.language === 'en'
                                    ? parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'en',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      )
                                    : parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'id',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      )) + (kontrakDetail?.sector_id == 3 ? ' MT' : ' Ton')
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_type_1_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('keterangan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_note}
                              as='textarea'
                              disabled
                              size='sm'
                              style={{height: '40px'}}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={
                                kontrakDetail.end_user_multiple
                                  ? handleShowValue(kontrakDetail.end_user)
                                  : kontrakDetail.end_user
                              }
                              as='textarea'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={t(kontrakDetail?.sector?.name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={7}>
                            {kontrakDetail?.incoterm2 == null ? (
                              <Form.Control
                                value={
                                  kontrakDetail?.incoterm2_id == null ||
                                  kontrakDetail?.incoterm2_id == '0'
                                    ? ''
                                    : kontrakDetail?.incoterm2_id
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={kontrakDetail?.incoterm2?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={kontrakDetail?.city?.city_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.product_type_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.product_spec}
                              as='textarea'
                              style={{height: '40px'}}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-hargaD')}/
                              {kontrakDetail?.product_type_desc == 'KANTONG/SACK'
                                ? kontrakDetail.unit
                                : kontrakDetail?.sector_id == 3
                                ? 'MT'
                                : 'Ton'}
                            </p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? parseInt(kontrakDetail?.price_contract).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : parseInt(kontrakDetail?.price_contract).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_type_2_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.notes}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {kontrakDetail?.sector_id == 3 && (
                    <Row>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>Sales Org</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.incoterm1?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={kontrakDetail?.province?.region_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.product_type_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('Plant')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.plant_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>
                              {kontrakDetail?.product_type_desc == 'KANTONG/SACK'
                                ? t('sack')
                                : t('Quantum')}
                            </p>
                          </Col>
                          <Col md={7}>
                            {kontrakDetail?.product_type_desc == 'KANTONG/SACK' ? (
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'en',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      ) + ' EA'
                                    : parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'id',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      ) + ' EA'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={
                                  (i18next.language === 'en'
                                    ? parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'en',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      )
                                    : parseInt(kontrakDetail?.quantum_contract).toLocaleString(
                                        'id',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      )) + (kontrakDetail?.sector_id == 3 ? ' MT' : ' Ton')
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={5}>
                            <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={7}>
                            <Form.Control
                              size='sm'
                              type='text'
                              id='shipping'
                              value={
                                kontrakDetail?.shipping_tolerance_contract !== '0'
                                  ? kontrakDetail?.shipping_tolerance_contract + '%'
                                  : ''
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_type_1_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('keterangan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_note}
                              as='textarea'
                              disabled
                              size='sm'
                              style={{height: '40px'}}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={
                                kontrakDetail.end_user_multiple
                                  ? handleShowValue(kontrakDetail.end_user)
                                  : kontrakDetail.end_user
                              }
                              as='textarea'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={t(kontrakDetail?.sector?.name)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={7}>
                            {kontrakDetail?.incoterm2 == null ? (
                              <Form.Control
                                value={
                                  kontrakDetail?.incoterm2_id == null ||
                                  kontrakDetail?.incoterm2_id == '0'
                                    ? ''
                                    : kontrakDetail?.incoterm2_id
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            ) : (
                              <Form.Control
                                value={kontrakDetail?.incoterm2?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              type='text'
                              value={kontrakDetail?.city?.city_name}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.product_name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={7}>
                            <FieldProductSpec data={kontrakDetail?.product_spec} type='editor' />
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>
                              {t('sub-order-hargaD')}/
                              {kontrakDetail?.product_type_desc == 'KANTONG/SACK'
                                ? kontrakDetail.unit
                                : kontrakDetail?.sector_id == 3
                                ? 'MT'
                                : 'Ton'}
                            </p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={'USD' + PriceFormater(kontrakDetail?.price_contract)}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        {/* <Row className='mb-5'>
                                              <Col sm={5}>
                                                <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                              </Col>
                                              <Col sm={7} className='d-flex justify-content-start'>
                                                <Form.Check
                                                  reverse
                                                  name='ppn'
                                                  className='mt-4 mb-2'
                                                  type='checkbox'
                                                  id='ckbox-ppn'
                                                  checked={kontrakDetail?.include_ppn}
                                                />
                                              </Col>
                                            </Row> */}
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.notes}
                              type='text'
                              as='textarea'
                              style={{height: '40px'}}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={5}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={kontrakDetail?.payment_type_2_desc}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                </Modal.Body>
              </Modal>

              <Modal
                show={showJadwal}
                onHide={() => {
                  setShowJadwal(false)
                  setJadwalID('')
                }}
                centered
                size='xl'
                backdrop='static'
                keyboard={false}
                scrollable
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
                    {productName} | {quantumContract} {tipeProduct != '8105' ? 'Ton' : unitProduct}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <AddRemoveJadwal id={jadwalID} is_amendment={'false'} tipeproduct={tipeProduct} unit={unitProduct}/>
                </Modal.Body>
              </Modal>

              <Modal
                show={showReject}
                onHide={() => setShowReject(false)}
                centered
                backdrop='static'
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t('order-alasanTolak')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                    <Form.Control
                      as='textarea'
                      placeholder={t('Tinggal-pesan')}
                      style={{height: '100px'}}
                      onChange={(e: any) => setRejectNote(e.target.value)}
                    />
                  </FloatingLabel>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='secondary' onClick={() => setShowReject(false)}>
                    {t('cancel')}
                  </Button>
                  <Button variant='danger' onClick={() => handleReject()} disabled={btnLoading}>
                    {btnLoading ? (
                      <Spinner animation='border' size='sm' />
                    ) : (
                      <>{t('order-tolak')}</>
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                show={showRevision}
                onHide={() => setShowRevision(false)}
                centered
                backdrop='static'
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t('alasan-revisi')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                    <Form.Control
                      as='textarea'
                      placeholder={t('Tinggal-pesan')}
                      style={{height: '100px'}}
                      onChange={(e: any) => {
                        setRevisionNote(e.target.value)
                      }}
                    />
                  </FloatingLabel>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='secondary' onClick={() => setShowRevision(false)}>
                    {t('order-tutup')}
                  </Button>
                  <Button variant='warning' onClick={() => handleRevisi()} disabled={btnLoadingg}>
                    {btnLoadingg ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      <>{t('order-revisi')}</>
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export {ApprovalKontrakDetail}
